import { Flex, Space, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useCtxGroupCompany } from '../../../../../features/companyGroup/queries/useCtxGroupCompany'
import SubsidiariesForm from '../../../../../features/companyGroup/components/SubsidiariesForm'
import { SubsidiariesTable } from '../../../../../features/companyGroup/components/SubsidiariesTable'
import Loading from '../../../../../shared/components/Loading'

export const Subsidiaries: React.FC = () => {
  const { t } = useTranslation()
  const { data: groupCompany, isLoading } = useCtxGroupCompany()

  if (isLoading) return <Loading />
  if (!groupCompany?.id) return null

  return (
    <Space direction="vertical" style={{ display: 'flex' }}>
      <Flex justify="space-between" align="center">
        <Typography.Text strong style={{ fontSize: 14 }}>
          {t('contractsPage:parent-company')}: {groupCompany.name}
        </Typography.Text>
        <SubsidiariesForm groupId={groupCompany.id} />
      </Flex>
      <SubsidiariesTable groupId={groupCompany.id} />
    </Space>
  )
}
